import React, { useLayoutEffect, useRef } from "react"

import Collapsible from '~components/Collapsible'
import SidebarResource from "./SidebarResource"
import { isResourcePath } from "./utils"

import * as style from "./Sidebar.module.scss"

const SidebarResources = ({
  resources, highlightSelected, open, microcopy, location,
}) => {
  const isResource = isResourcePath(location.pathname)
  const pathToLookFor = location.pathname
  const isSelected = highlightSelected && resources.some((e) => e.path === pathToLookFor)

  const selectedItemRef = useRef(null)

  useLayoutEffect(() => {
    if (isSelected) {
      const scrollConfig = { behavior: "instant", block: "center" }
      selectedItemRef.current?.scrollIntoView(scrollConfig)
    }
  }, [isSelected, selectedItemRef])

  return (
    <Collapsible
      header={(
        <h3>
          <span className={isSelected ? style.activeParent : ''}>
            {microcopy.text("reference.titles.other_resources")}
          </span>
        </h3>
          )}
      className={`${style.collapsible} ${style.tag}`}
      headerClassName={`${style.level_1} ${style.collapsibleHeader}`}
      open={open || isSelected}
    >
      <ul className={style.collapsibleBody}>
        {resources.map((resource) => (
          <li key={resource.id} ref={resource.path === pathToLookFor ? selectedItemRef : undefined}>
            <SidebarResource
              location={location}
              resource={resource}
              // eslint-disable-next-line max-len
              className={`${style.level_2} ${highlightSelected && resource.path === pathToLookFor ? style.activeEntry : ''}`}
            />
          </li>
        ))}
      </ul>
    </Collapsible>
  )
}

export default SidebarResources
